import { deleteData, getData, postData } from '../../../helpers/axiosHelper';
import { queryString } from '../../../utils/heap';

import { CONNECTIONS_ENDPOINT } from '../consts';
import {
  ICreateAdverityConnectionRequestData,
  IGetAdverityConnectionTypesResponseData,
  IGetAdverityAvailablePlatformsResponseData,
  IGetAuthorizedConnectionResponseData,
  IGetConnectionLinkedAccountResponseData,
  ICreateFivetranConnectionRequestData,
  IGetFivetranConnectionsResponseData,
  IGetFivetranConnectionTypesResponseData,
  ICreateFivetranConnectionResponseData,
  IAuthorizeFivetranConnectionResponseData,
  ICancelConnectionRequestData,
  IUnlinkConnectionRequestData,
} from '../types';

// BE: bad response body
export const getConnectionTypes =
  async (): Promise<IGetAdverityConnectionTypesResponseData> => {
    const url = `${CONNECTIONS_ENDPOINT}/types`;
    return getData(url);
  };

// BE: typo in response property
export const getListOfAvailablePlatforms =
  async (): Promise<IGetAdverityAvailablePlatformsResponseData> => {
    const url = `${CONNECTIONS_ENDPOINT}/adverity-connections`;
    return getData(url);
  };

export const createConnection = async (
  data: ICreateAdverityConnectionRequestData
): Promise<string> => {
  const {
    connectionTypeId,
    domainName,
    customerId,
    appsflyerApiToken,
    openAiApiKey,
    woocommerceInfo,
  } = data;
  const url = `${CONNECTIONS_ENDPOINT}`;

  return postData(
    queryString.stringifyUrl({
      url,
      query: {
        connectionTypeId,
        domainName,
        customerId,
        appsflyerApiToken,
        openAiApiKey,
      },
    }),
    woocommerceInfo || null
  );
};

export const cancelConnection = async (
  data: ICancelConnectionRequestData
): Promise<void> => {
  const url = `${CONNECTIONS_ENDPOINT}`;
  return deleteData(
    queryString.stringifyUrl({
      url,
      query: {
        ...data,
      },
    })
  );
};

// BE: bad response body
export const getConnectionsLinkedAccount = async (
  linkedAccountId: string
): Promise<IGetConnectionLinkedAccountResponseData> => {
  const url = `${CONNECTIONS_ENDPOINT}`;
  return getData(url, { linkedAccountId });
};

export const authorizeConnection = async (
  linkedAccountId: string
): Promise<IGetAuthorizedConnectionResponseData> => {
  const url = `${CONNECTIONS_ENDPOINT}/authorize`;
  return getData(url, { linkedAccountId });
};

export const unlinkAccount = async (
  data: IUnlinkConnectionRequestData
): Promise<void> => {
  const url = `${CONNECTIONS_ENDPOINT}/unlink`;
  return deleteData(
    queryString.stringifyUrl({
      url,
      query: {
        ...data,
      },
    })
  );
};

export const createFivetranConnection = async ({
  data,
  customerId,
}: ICreateFivetranConnectionRequestData): Promise<ICreateFivetranConnectionResponseData> => {
  const url = `${CONNECTIONS_ENDPOINT}/fivetran/connection`;

  return postData(
    queryString.stringifyUrl({
      url,
      query: {
        customerId,
      },
    }),
    data
  );
};

export const deleteFivetranConnection = async (
  connectionId: string
): Promise<void> => {
  const url = `${CONNECTIONS_ENDPOINT}/fivetran/connection`;
  return deleteData(url, { connectionId });
};

export const authorizeFivetranConnection = async (
  connectionId: string
): Promise<IAuthorizeFivetranConnectionResponseData> => {
  const url = `${CONNECTIONS_ENDPOINT}/fivetran/connection/verify-authorization`;
  return getData(url, { connectionId });
};

export const getFivetranConnections = async (
  customerId?: string
): Promise<IGetFivetranConnectionsResponseData> => {
  const url = `${CONNECTIONS_ENDPOINT}/fivetran/connections`;
  return getData(
    queryString.stringifyUrl({
      url,
      query: {
        customerId,
      },
    })
  );
};

export const getFivetranConnectionTypes =
  async (): Promise<IGetFivetranConnectionTypesResponseData> => {
    const url = `${CONNECTIONS_ENDPOINT}/fivetran/types`;
    return getData(url);
  };
